<template>
  <a :href="link" :title="title">
    <nuxt-img width="40" :src="`/images/flags/${country}.svg`" />
    <div>
      <span>{{ name }}</span>
      <span>in {{ countryName }}</span>
    </div>
  </a>
</template>
<script>
export default {
  name: 'CountryLink',
  props: {
    link: { type: String, required: true },
    country: {
      type: String,
      default: undefined,
    },
    countryName: {
      type: String,
      default: undefined,
    },
    name: { type: String, default: undefined },
    title: { type: String, default: undefined },
  },
};
</script>
<style scoped lang="scss">
a {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: 0.5rem;
  font-size: $font-size-200;
  color: $color-text-lightest;
  &:hover,
  &:focus {
    color: $color-link;
  }
  div {
    flex: nowrap;
    display: flex;
    flex-direction: column;
  }
}
@media screen and (min-width: 512px) {
  a {
    gap: 1rem;
    div {
      width: 20em;
      span:first-child {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
